import type { ButtonProps } from '@lingoda/ui';
import { Button } from '@lingoda/ui';
import { LockIcon } from '@lingoda/ui/icons/lingodaIcons';
import { goTo, subscriptionsStorePath } from '@lingoda/router';
import type { FC } from 'react';

export interface BookButtonProps extends Omit<ButtonProps, 'variant' | 'color'> {
    outlined?: boolean;
    locked: boolean;
    onLockedRedirect?: () => void;
    children: string;
}

export const BookButton: FC<BookButtonProps> = ({
    outlined,
    locked,
    children,
    onLockedRedirect,
    ...rest
}) => {
    const handleLockedButtonClick: NonNullable<BookButtonProps['onClick']> = (e) => {
        e.stopPropagation();
        e.preventDefault();
        onLockedRedirect?.();
        goTo(subscriptionsStorePath());
    };

    if (!locked) {
        return (
            <Button color="primary" variant={outlined ? 'outlined' : 'contained'} {...rest}>
                {children}
            </Button>
        );
    }
    if (outlined) {
        return (
            <Button
                startIcon={<LockIcon size={16} style={{ marginBottom: 1 }} />}
                {...rest}
                onClick={handleLockedButtonClick}
                color="primary"
                variant="outlined"
            >
                {children}
            </Button>
        );
    }

    if (!outlined) {
        return (
            <Button
                startIcon={<LockIcon size={16} style={{ marginBottom: 1 }} />}
                {...rest}
                onClick={handleLockedButtonClick}
                color="primary"
                variant="contained"
            >
                {children}
            </Button>
        );
    }
};
